import axios from 'axios';

// Get API URL from environment variables - throw error if missing
const API_URL = process.env.REACT_APP_API_URL;
if (!API_URL) {
  throw new Error('REACT_APP_API_URL environment variable is not set');
}

// Get auth storage key from environment variables - throw error if missing
const AUTH_STORAGE_KEY = process.env.REACT_APP_AUTH_STORAGE_KEY;
if (!AUTH_STORAGE_KEY) {
  throw new Error('REACT_APP_AUTH_STORAGE_KEY environment variable is not set');
}

const TIMEOUT = 10000;

// Create an axios instance with base URL and common configuration
const api = axios.create({
  baseURL: API_URL, // API_URL already includes full path
  timeout: TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
  // Use withCredentials with specific origins CORS
  withCredentials: true,
});

// Add request interceptor to include auth token for all requests
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = localStorage.getItem(AUTH_STORAGE_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for handling common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle different error statuses
    if (error.response) {
      // Server responded with a status code outside the 2xx range
      if (error.response.status === 401) {
        // Unauthorized: Clear local storage and redirect to login
        localStorage.removeItem(AUTH_STORAGE_KEY);
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
